import { ApiComm } from '../comm';
import { ResponseDTO } from '../dto/ResponseDTO';
import { DashboardSummaryDTO } from '../dto/DashboardDTOs';
import { genNoobookHeader } from './Common';

/**
 * 대시보드 요약 데이터 조회
 * @param authToken 인증 토큰
 * @param startDate 시작일 (YYYY-MM-DD)
 * @param endDate 종료일 (YYYY-MM-DD)
 */
export function getDashboardSummary(
  authToken: string,
  startDate?: string,
  endDate?: string
): Promise<ResponseDTO<DashboardSummaryDTO>> {
  // TODO: 서버 API가 준비되면 아래 주석을 해제하고 mock 함수를 제거
  /*
  const params: any = {};
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;

  return ApiComm.getData<ResponseDTO<DashboardSummaryDTO>>(
    '/admin/v1/dashboard/summary',
    params,
    genNoobookHeader(authToken, null, 'application/json', 'app')
  ).then(resp => resp.data);
  */

  // Mock data 반환 (서버 API 준비 전까지 사용)
  return new Promise((resolve) => {
    setTimeout(() => {
      const mockData: DashboardSummaryDTO = {
        totalUsers: 7004,
        newUsers: 36,
        reportSummary: 2,
        reportReviewPending: 0,
        ongoingEventBanner: {
          title: '진행 중 이벤트 나리기!',
          description: '별입 어떻사 모든',
          imageUrl: null,
        },
        currentReadingBooks: 16,
        currentScriptingBooks: 4,
        ongoingGatherings: 2,
        newGatherings: 1,
        totalReadingTime: '20:3h',
        averageSessionTime: '00:27',
      };

      const response: ResponseDTO<DashboardSummaryDTO> = {
        errorCode: 0,
        response: mockData,
        page: {
          current: 1,
          last: 1,
          total: 1,
        },
      };

      resolve(response);
    }, 300); // API 호출 시뮬레이션을 위한 약간의 지연
  });
}
